import { Locale } from 'modules/i18n';

export const buttonsTranslation = {
  [Locale.en]: {
    switchButton: 'Switch to Personal account',
    cancelButton: 'Cancel',
  },
};
